<template>
  <div class="section">
    <news-floating :is-open="showNews" :fetch-news-page="fetchNewsPage" @close="showNews = false" />
    <div class="news-toggle">
      <button class="news-toggle__button" type="button" @click="toggleNews" aria-label="Conoce las nuevas en Intelligential">
        <span class="news-toggle__icon">
          <i class="fas fa-bullhorn"></i>
        </span>
        <span class="news-toggle__text">Conoce las nuevas en Intelligential</span>
      </button>
    </div>
    <div class="container">
      <p class="has-text-centered" id="title-dashboard">
        Bienvenido <strong>¿Qué deseas hacer hoy?</strong>
      </p>
      <div class="columns is-multiline is-centered">
        <div class="column is-12" v-if="loading">
          <loading />
        </div>
        <div class="column is-3" v-if="customerMenu">
          <div class="card">
            <div class="card-content">
              <div class="content-principal">
                <img src="@/assets/clientes.svg"/>
                <h1 class="titleCard">Clientes</h1>
                <p class="description">Crea y gestiona el expediente de tu cartera de clientes</p>
              </div>
              <a :href="getLinkLocal({ section: 'general', path: customerMenu.path })" class="link">
                Ver más
                <i class="fa fa-angle-right" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>

        <div class="column is-3" v-if="applicationMenu">
          <div class="card">
            <div class="card-content">
              <div class="content-principal">
                <img src="@/assets/solicitudes.svg"/>
                <h1 class="titleCard">Solicitudes</h1>
                <p class="description">Revisa, gestiona, analiza, otorga o rechaza las solicitudes de crédito</p>
              </div>
              <a :href="getLinkLocal({ section: 'analyst', path: applicationMenu.path })" class="link">
                Ver más
                <i class="fa fa-angle-right" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>

        <div class="column is-3" v-if="contractMenu">
          <div class="card">
            <div class="card-content">
              <div class="content-principal">
                <img src="@/assets/creditos.svg"/>
                <h1 class="titleCard">Créditos</h1>
                <p class="description">Observa el comportamiento de tu cartera de créditos otorgados</p>
              </div>
              <a :href="getLinkLocal({ section: 'core', path: contractMenu.path })" class="link">
                Ver más
                <i class="fa fa-angle-right" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>

        <div class="column is-3" v-if="buzonPldMenu">
          <div class="card">
            <div class="card-content">
              <div class="content-principal">
                <img src="@/assets/buzon-pld.svg"/>
                <h1 class="titleCard">Buzón PLD</h1>
                <p class="description">Registra tus observaciones de comportamientos anormales</p>
              </div>
              <a :href="getLinkLocal({ section: 'pld', path: buzonPldMenu.path })" class="link">
                Ver más
                <i class="fa fa-angle-right" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  components: {
    Loading: () => import('@/components/ui/Loading.vue'),
    NewsFloating: () => import('@/components/Dashboard/NewsFloating.vue')
  },
  data () {
    return {
      loading: true,
      menu: [],
      showNews: false

    }
  },
  methods: {
    ...mapActions(['getMenu', 'getIntelligentialNews']),
    fetchNewsPage ({ cursor, limit }) {
      return this.getIntelligentialNews({ cursor, limit })
    },
    toggleNews () {
      this.showNews = !this.showNews
    },
    getLinkLocal ({ section, path }) {
      if (section === 'external') {
        return path
      }
      const baseURL = `${process.env.VUE_APP_PROTOCOL}://${window.location.hostname}`
      const linkPath = path ? `${process.env[`VUE_APP_${section.toUpperCase()}`]}/${path}`.replace('//', '/') : ''
      return `${baseURL}${linkPath}`
    }
  },
  computed: {
    applicationMenu () {
      if (this.menu) {
        const menuSelected = this.menu.reduce((accum, category) => {
          const itemList = category.subcategories.reduce((accumItem, el) => (accumItem = [...accumItem, ...el.items]), [])
          return [...accum, ...itemList]
        }, []).find(item => item.name === 'Solicitudes')
        return menuSelected
      }
      return null
    },
    customerMenu () {
      if (this.menu) {
        const menuSelected = this.menu.reduce((accum, category) => {
          const itemList = category.subcategories.reduce((accumItem, el) => (accumItem = [...accumItem, ...el.items]), [])
          return [...accum, ...itemList]
        }, []).find(item => item.name === 'Clientes')
        return menuSelected
      }
      return null
    },
    contractMenu () {
      if (this.menu) {
        const menuSelected = this.menu.reduce((accum, category) => {
          const itemList = category.subcategories.reduce((accumItem, el) => (accumItem = [...accumItem, ...el.items]), [])
          return [...accum, ...itemList]
        }, []).find(item => item.name === 'Créditos')
        return menuSelected
      }
      return null
    },
    buzonPldMenu () {
      if (this.menu) {
        const menuSelected = this.menu.reduce((accum, category) => {
          const itemList = category.subcategories.reduce((accumItem, el) => (accumItem = [...accumItem, ...el.items]), [])
          return [...accum, ...itemList]
        }, []).find(item => item.name === 'Buzón PLD')
        return menuSelected
      }
      return null
    }
  },
  created () {
    const agentWidget = document.getElementById('agentWidget')
    agentWidget.style.display = 'block'
    this.getMenu()
      .then(resp => {
        this.menu = resp.categories
        this.loading = false
      })
  }

}
</script>

<style lang="scss" scoped>
.is-fullheight {
  min-height: calc(100vh - 66px);
}
.section {
  width: 100%;
  padding-top: 4rem;
}
p {
  font-size: 16px;
  font-weight: 500;
  color: #2e3e50;
}
.card {
  margin-top: 1.5rem;
  border-radius: 10px;
  box-shadow: 0 6px 30px 0 rgba(0, 0, 0, 0.1);
}
.card-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  min-height: 400px;
  padding: 0.5 1rem;
  img {
    width: 150px;
    height: 140px;
  }
  .content-principal {
    padding-top: 1rem;
    text-align: center;
  }
  .titleCard {
    font-size: 20px;
    font-weight: 700;
    color: #283056;
    text-align: center;
  }
  .description {
    font-size: 12px;
    color: #888888;
    text-align: center;
    margin-top: 1rem;
  }
  .link {
    font-size: 14px;
    color: #5174ff;
    text-align: right;
    width: 100%;
    font-weight: 500;
    padding-right: 0.5rem;
  }
}
#title-dashboard {
  margin-bottom: 0.5rem;
}
.news-toggle {
  position: fixed;
  right: 5.25rem;
  bottom: 0rem;
  transform: translateY(-50%);
  z-index: 34;
}
.news-toggle__button {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.55rem 0.9rem;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: #1f2937;
  color: #e5e7eb;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.25);
}
.news-toggle__button:hover {
  background: #273449;
}
.news-toggle__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.12);
}
.news-toggle__text {
  white-space: nowrap;
}
@media (max-width: 768px) {
  .news-toggle {
    right: 8px;
  }
}
</style>
